import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import styles from './ActionBar.css'
import {
  changeDateFeedback
} from 'actions/customers/feedback'
import MenuTitle from 'components/MenuTitle'

class ActionBar extends React.Component {
  render () {
    return (
      <div>
        <MenuTitle menuTitle='Feedback' />
        <div className='col-sm-12 col-xs-8'>
          <form className='form-inline' onSubmit={() => false}>
            <div className={`form-group ${styles['form-group']}`}>
              <Field
                component={DropdownCalendar}
                name='date'
                onChange={this._onChangeDate}
              />
            </div>
          </form>
        </div>
      </div>
    )
  }

  _onChangeDate = ({startDate, endDate}) => {
    this.props.dispatch(changeDateFeedback(startDate, endDate))
    $('#customer-feedback').show()
  };
}

function mapStateToProps (state) {
  return {
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'search'
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/ActionBar/ActionBar.js